import React from "react";
import classNames from "classnames";
import withStyles from "@material-ui/core/styles/withStyles";

import DefaultLayout from "layouts/default.jsx";
import Hidden from "@material-ui/core/Hidden";

import { Helmet } from 'react-helmet'

import { SnackbarProvider } from 'notistack';

// core components
import Header from "components/Header/Header.jsx";
import Footer from "components/Footer/Footer.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import HeaderLinks from "components/Header/HeaderLinks.jsx";
import Banner from "components/Banner/Banner.jsx";
import Quote from "components/Quote/Quote.jsx";
import QuoteFact from "components/QuoteFact/QuoteFact.jsx";
import Fact from "components/Fact/Fact.jsx";
import WaitlistForm from "components/WaitlistForm/WaitlistForm.jsx";

import landingPageStyle from "assets/jss/material-kit-react/views/landingPage.jsx";
import parallaxStyle from "assets/jss/material-kit-react/components/parallaxStyle.jsx"

import facts from "data/facts.json";
import quotes from "data/quotes.json";

// Sections for this page
import AboutMiniSection from "sections/LandingPage/AboutMiniSection.jsx";
import AboutUsSection from "sections/LandingPage/AboutUsSection.jsx";
import FeaturesSection from "sections/LandingPage/FeaturesSection.jsx";
import ProductSection from "sections/LandingPage/ProductSection.jsx";
import MissionSection from "sections/LandingPage/MissionSection.jsx";

import EarlyAdopterCTA from "sections/CTAs/EarlyAdopterCTA.jsx";
import MissingStepCTA from "sections/CTAs/MissingStepCTA.jsx";
import YourSharesMyFutureCTA from "sections/CTAs/YourSharesMyFutureCTA.jsx";

import Organize from "components/Background/Organize.jsx";
import homeImage from "assets/img/home.png";

const filter = parallaxStyle.filter;

class LandingPage extends React.Component {
  render() {
    const { classes, ...rest } = this.props;
    return (
      <DefaultLayout>
        <Helmet>
          <meta property="og:url" content={`https://wetheshareholders.com`}/>
          <meta property="og:image" content={`https://wetheshareholders.com${homeImage}`}/>
          <meta name="twitter:image" content={`https://wetheshareholders.com${homeImage}`}/>
          <meta property="og:image:alt" content="A group of demonstrators exercising their civic rights. One is holding a loudspeaker and others have their fists raised up in the air."/>
          <meta name="twitter:image:alt" content="A group of demonstrators exercising their civic rights. One is holding a loudspeaker and others have their fists raised up in the air."/>
        </Helmet>
        <Banner BackgroundImage={Organize}>
          <div className={classNames(classes.container, classes.filter)}>
            <GridContainer >
              <GridItem className={classes.gridContainerItem} xs={11} sm={10} md={8} >
                <h1 className={classes.title}>Join the Movement.
                </h1>
                <h2 className={classes.subtitle}><span className={classes.inlineBlock}>Change corporations.&nbsp;</span><span className={classes.inlineBlock}>Change the world.</span></h2>
                <h4> 
                  <span className={classes.block}>Reclaim your shareholder voting rights and hold Corporate America accountable.</span>
                  <br/><span className={classes.block}>You'll receive important updates, exclusive content, and early access to our platforms and products.</span>
                </h4>
                <br />
                  <WaitlistForm classes={classes}  listIds={[9, 25]}/>
              </GridItem>
            </GridContainer>
          </div>
        </Banner>
        <div className={classNames(classes.main)}>
          <div>
          <AboutMiniSection/>
          </div>
        </div>
        <QuoteFact quote={quotes.webber} facts={[facts.stockOwnership, facts.proxyVotingRate]}/>
        <ProductSection />
        <QuoteFact quote={quotes.roosevelt} facts={[facts.institutionalVotingPower,facts.incomeInequality]}/>
        <YourSharesMyFutureCTA listIds={[10]}/>
        <QuoteFact quote={quotes.schwab} facts={[facts.capitalismHarm, facts.capitalismGood]}/>
        <MissionSection/>
        <QuoteFact quote={quotes.bogel} facts={[facts.shareholderVotingRights, facts.proxyVotingRateAlt]}/>             
        <MissingStepCTA listIds={[11]}/>
        <QuoteFact quote={quotes.strineOne} facts={[facts.institutionalOwnership1950, facts.institutionalOwnership2020]}/>
        <AboutUsSection/>        
        <EarlyAdopterCTA listIds={[12]}/>
        <Footer />
      </DefaultLayout>
    );
  }
}

export default withStyles(landingPageStyle)(LandingPage);
